import { UserPhonesClient} from '@/apiClients';
import authorizedClient from './authorizedClient';

export default {
  namespaced: true as true, 
  actions: {
    async DeregisterPhone({ commit }: any, id: string): Promise<void> {
          const userPhonesClient = await authorizedClient(UserPhonesClient);
          await userPhonesClient.deregister(id, process.env.VUE_APP_TERMINAL_WEB_API_VERSION);
        },
  },
};